import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CommonFilterStructure from "../common-components/CommonFilterStructure";
import ReceptionistAttendanceTab from "./checkedin-notcheckedin/ReceptionistAttendanceTab";
import { convertStraight } from "../common-data/Converts";
import { fetchReceptionistAttendance } from "../../redux/reducers/apiSlice";
import ReactVortoxSpinner from "../common-components/ReactVortoxSpinner";

const ReceptionistAttendance = ({ userInfoData, prevFilters }) => {
  const dispatch = useDispatch();
  const { receptionistAttendance, receptionistAttendanceLoading } = useSelector(
    (state) => state.api
  );
  const [isPage, setIsPage] = useState(0);
  const initialFilters = { selectedOtherUsers: "" };
  const [allFilters, setAllFilters] = useState(initialFilters);
  const iniFilters = {
    limit: 10,
    page: isPage + 1,
    user_id: allFilters.selectedOtherUsers?.value || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const iniTbDatas = {
    allData: null,
    pagination: [],
  };
  const [tbDatas, setTbDatas] = useState(iniTbDatas);

  const onClickReset = () => {
    setAllFilters(initialFilters);
    setFilters(iniFilters);
  };

  function getReceptionistAttendance() {
    const { date_from, date_to, ...rest } = prevFilters;
    const pieChartGetApiFilters = {
      ...rest,
      account_type: "staff",
      date_from: convertStraight(date_from),
      date_to: convertStraight(date_to),
      ...filters,
    };

    dispatch(
      fetchReceptionistAttendance({
        filters: pieChartGetApiFilters,
        token: userInfoData?.token,
      })
    );
  }

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      user_id: allFilters.selectedOtherUsers?.value || "",
    }));
  }, [allFilters, isPage]);

  useEffect(() => {
    getReceptionistAttendance();
  }, [prevFilters, filters]);

  useEffect(() => {
    if (receptionistAttendance?.status && receptionistAttendance?.data) {
      setTbDatas((prevs) => ({
        ...prevs,
        allData: receptionistAttendance.data,
        pagination: receptionistAttendance?.pagination || [],
      }));
    } else {
      setTbDatas(iniTbDatas);
    }
  }, [receptionistAttendance]);

  return (
    <>
      <CommonFilterStructure
        from={"trainer-checkedin-notcheckedin"}
        decryptedText={userInfoData}
        setFilters={setAllFilters}
        filters={allFilters}
        onClickReset={onClickReset}
        isReceptionists={true}
        otherUserLabel={"Sales Executive"}
      />

      {receptionistAttendanceLoading ? (
        <ReactVortoxSpinner />
      ) : (
        <ReceptionistAttendanceTab
          tbDatas={tbDatas}
          isPage={isPage}
          setIsPage={setIsPage}
        />
      )}
    </>
  );
};

export default ReceptionistAttendance;
